//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { SamplingCampaignRequest } from '@apis/campaign-requests/sampling/campaign-requests/samplingCampaignRequestsApiModel';
import { CreatorCampaignRequest } from '@apis/campaign-requests/shared/CampaignRequests';
import { ValidationRules } from '@campaigns/types/ValidationRulesType';

export const CREATOR_DETAILS_VALIDATION_ERROR_MESSAGES = {
  CITY: "Invalid city name. Use only letters, spaces, -, and '",
  EMAIL: 'Enter a valid email address.',
  NAME: 'Invalid name. Use only letters, "-", and "\'""',
  PHONE: 'Invalid phone number. Must include country code.',
  POSTAL_CODE: 'Invalid postal code. No special characters.',
  STATE: 'Invalid state name. Use letters only',
  URL: 'Enter a valid URL with protocol (http:// or https://)',
} as const;

// TODO: [CREATORS] Add validation rules for creator campaign requests
export const CAMPAIGN_REQUEST_FORM_VALIDATION: Partial<
  ValidationRules<SamplingCampaignRequest | CreatorCampaignRequest>
> = {
  name: {
    required: {
      message: 'Please enter a name for this campaign',
      value: true,
    },
  },
  targetClientId: {
    required: {
      message: 'Please select a retailer',
      value: true,
    },
  },
  type: {
    required: {
      message: 'Please select a campaign type',
      value: true,
    },
  },
};
